export { default } from './hidden-label';